(function(angular){
	'use strict';
	
	angular.module('dripFeatureModule', [
		'coreModule',
		'futureEarningsChartModule'
	]);

})(window.angular);